import FacilitySettingsPage from '@/features/companies/[companyId]/facilities/[facilityId]/settings/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authed/companies/$companySlug/facilities/$facilitySlug/settings',
)({
  component: FacilitySettingsPage,
})
